import React, { useEffect, useState } from "react";
import Login from "./components/pages/login";
import ForgotPassword from "./components/pages/login/ForgotPassword";
import Signup from "./components/pages/login/Signup";
import Register from "./components/pages/login/Register";
import LockScreen from "./components/pages/login/LockScreen";
import ChangePassword from "./components/pages/login/ChangePassword";
import Error from "./components/pages/login/Error";
import ServerError from "./components/pages/login/ServerError";
import Profile from "./components/pages/login/Profile";
import EditProfile from "./components/pages/login/EditProfile";
import BlankPage from "./components/pages/login/BlankPage";
import GalleryImage from "./components/pages/Gallery/Gallery";
import DemoApi from "./components/pages/demoApi/DemoApi";
import Card_PatientDashboard from "./components/Dashboard/Card_Dashboard/Card_PatientDashboard";
import AppointmentPatient from "./components/Dashboard/cardinformation/AppointmentPatient";
import CareTeamPatient from "./components/Dashboard/cardinformation/CareTeamPatient";
import UpcommingPatientAppointment from "./components/Dashboard/cardinformation/UpcommingPatientAppointment";
import BookNowDoctor from "./components/extra/BookNowDoctor";
import Form from "./components/extra/Form";
import Encounter from "./components/extra/Encounter";
import PatientBMI from "./components/extra/PatientBMI";
import PateintDocument from "./components/extra/PateintDocument";
import DoctorSideBar from "./doctor/DoctorSideBar";
import DoctorHeader from "./doctor/DoctorHeader";
import DoctorDashboard from "./doctor/DoctorDashboard";
import DoctorChronicManagement from "./doctor/DoctorChronicManagement";
import DoctorGuideline from "./doctor/DoctorGuideline";
import DoctorAnnual from "./doctor/DoctorAnnual";
import DoctorProfile from "./doctor/DoctorProfile";
import DoctorEditProfile from "./doctor/DoctorEditProfile";
import DoctorMyPatient from "./doctor/DoctorMyPatient";
import DoctorAppointment from "./doctor/DoctorAppointment";
import DoctorEncounter from "./doctor/DoctorEncounter";
import Studies from "./components/pages/Studies/Studies";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./routes/ProtectedRoute";
import useSessionManagement from "./hooks/useSessionManagement";
import { Navigate, Route, Routes } from "react-router-dom";
// import ManageUsers from "./components/pages/users/ManageUsers";

import GradeTable from "./components/pages/Grades/Grade/GradeTable";
import RadiologistUser from "./components/pages/User/RadiologistUsers";
import PriorityTable from "./components/pages/Grades/Priorty/PriorityTable";
import QualityTable from "./components/pages/Grades/Quality/QualityTable";
import CentersTable from "./components/pages/Grades/Centers/CentersTable";
import UserDetails from "./components/pages/User/UserDetails";
import TemplateTable from "./components/pages/ModalityTemplate/TemplateTable";
import CategoryTable from "./components/pages/Categories/CategoryTable";
import Reports from "./components/pages/Reports/Reports";
// import ManageAvailability from "./components/pages/Availability/ManageAvailability";
import RadiologistSlotsTable from "./components/pages/RadiologistSlots/RadiologistSlotsTable";
import { getToken } from "firebase/messaging";
import StudyTimeline from "./components/pages/Timeline/StudyTimeline";
import Chat from "./components/pages/chat/Chat";
import useUser from "./hooks/useUser";
import RedirectViewer from "./components/RedirectViewer";
import { socket } from "./utils/socket";
import apiClient from "./utils/apiClient";
import { messagingResolve } from "./firebase/firebaseConfig";
import Machine from "./components/pages/Machine/Machine";
import Viewer from "./components/pages/viewer/Viewer";
const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;
const Approuter = () => {
  const { userID } = useUser();
  const [fcmToken, setFcmToken] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    socket.connect();
  }, []);
  // Firebase credentials
  useEffect(() => {
    const registerServiceWorker = async () => {
      try {
        if (
          "serviceWorker" in navigator &&
          "PushManager" in window &&
          typeof window.navigator.serviceWorker !== "undefined"
        ) {
          const registration = await navigator.serviceWorker.register(
            `/firebase-messaging-sw.js`
          );
          console.log("Service Worker registered with scope:", registration);
        }
      } catch (err) {
        setError("Service Worker registration failed: " + err?.message || "");
        console.error("Service Worker registration failed:", err || "");
      }
    };

    const requestPermissionAndGenerateToken = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          setError("Permission denied for notifications.");
        } else {
          console.log("permission is allowed");
        }
        // console.log("messaging-->", messagingResolve);
        let token;
        // await registerServiceWorker();
        // console.log("message resolve-->", messagingResolve);
        if (messagingResolve) {
          token = await getToken(messagingResolve, {
            vapidKey: VAPID_KEY,
          });
        } else {
          console.log("Error in generating token");
        }
        if (token) {
          setFcmToken(token);
        } else {
          setError("Failed to get FCM token.");
        }
      } catch (err) {
        setError(" getting FCM token: " + err || "");
        console.error("Error during Firebase messaging setup:", err);
      }
    };
    registerServiceWorker();
    requestPermissionAndGenerateToken();
  }, [messagingResolve, VAPID_KEY]);
  useEffect(() => {
    const updateToken = async () => {
      const res = await apiClient.patch("/users/update-deviceToken", {
        user_id: userID,
        device_token: fcmToken,
      });

      // Retrieve the existing 'UserData' object from localStorage
      let UserData = JSON.parse(localStorage.getItem("UserData")) || {};

      // Update or initialize the 'device_token' within the 'tokens' object
      UserData.tokens = UserData.tokens || {}; // Ensure tokens object exists
      UserData.tokens.device_token = { token: fcmToken };

      // Store the updated 'UserData' object back in localStorage
      localStorage.setItem("UserData", JSON.stringify(UserData));
      console.log("response-->", res);
    };

    let UserData = localStorage.getItem("UserData");
    if (!UserData?.tokens?.device_token?.token && userID && fcmToken) {
      updateToken();
    }
  }, [fcmToken, userID]);
  useSessionManagement();
  if (error) console.log(error);
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            userID ? (
              <Navigate to="/studies" />
            ) : (
              <Login FCMToken={fcmToken} tokenError={error} />
            )
          }
        />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/v1/auth/image-url/:timeStamp"
          element={<RedirectViewer />}
        />

        {/* Protected Routes */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Routes>
                <Route
                  path="/"
                  element={userID ? <Navigate to="/studies" /> : <Login />}
                />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/edit-profile" element={<EditProfile />} />
                <Route path="/demo-api" element={<DemoApi />} />
                <Route path="/studies" element={<Studies />} />
                <Route path="/register" element={<Register />} />
                <Route path="/lockscreen" element={<LockScreen />} />
                <Route path="/changepassword" element={<ChangePassword />} />
                <Route path="/error" element={<Error />} />
                <Route path="/server-error" element={<ServerError />} />
                {/* <Route path="/machine" element={<ServerError />} /> */}
                <Route
                  path="/viewer/:studyId/:radiologistId/:studyInfoId"
                  element={<Viewer />}
                />
                <Route path="/chat" element={<Chat />} />
                {/* <Route path="/reports" element={<Reports />} /> */}

                <Route path="/blankpage" element={<BlankPage />} />
                <Route path="/machine" element={<Machine />} />
                <Route path="/gallery" element={<GalleryImage />} />
                <Route
                  path="/studies"
                  element={<Studies fcmToken={fcmToken} />}
                />
                {/* <Route path="/manageusers" element={<ManageUsers />} /> */}
                <Route path="/gradetable" element={<GradeTable />} />
                <Route path="/prioritytable" element={<PriorityTable />} />
                <Route path="/qualitytable" element={<QualityTable />} />
                <Route path="/centerstable" element={<CentersTable />} />
                <Route path="/templates" element={<TemplateTable />} />
                <Route path="/categories" element={<CategoryTable />} />
                <Route path="/reports" element={<Reports />} />
                {/* <Route path="/avalabilities" element={<ManageAvailability />} /> */}
                <Route
                  path="/radiologistslots"
                  element={<RadiologistSlotsTable />}
                />

                <Route
                  path="/studyTimeline/:id"
                  element={<StudyTimeline />}
                ></Route>

                {/* Patient */}
                <Route
                  path="/card-patientdashboard"
                  element={<Card_PatientDashboard />}
                />
                <Route path="/appointment" element={<AppointmentPatient />} />
                <Route path="/careteampatient" element={<CareTeamPatient />} />
                <Route
                  path="/upcomming"
                  element={<UpcommingPatientAppointment />}
                />
                <Route path="/booknow" element={<BookNowDoctor />} />
                <Route path="/booknowform" element={<Form />} />
                <Route path="/encounter" element={<Encounter />} />
                <Route path="/bmistatus" element={<PatientBMI />} />
                <Route path="mydocument" element={<PateintDocument />} />

                {/* Doctor */}
                <Route path="/doctorsidebar" element={<DoctorSideBar />} />
                <Route path="/manageusers" element={<RadiologistUser />} />
                <Route path="/manageusers/:id" element={<UserDetails />} />
                <Route path="/doctorheader" element={<DoctorHeader />} />
                <Route path="/doctordashboard" element={<DoctorDashboard />} />
                <Route path="/chronic" element={<DoctorChronicManagement />} />
                <Route path="/guideline" element={<DoctorGuideline />} />
                <Route path="/annual" element={<DoctorAnnual />} />
                <Route path="/doctorprofile" element={<DoctorProfile />} />
                <Route
                  path="/doctoreditprofile"
                  element={<DoctorEditProfile />}
                />
                <Route path="/mypatient" element={<DoctorMyPatient />} />
                <Route
                  path="/doctorappointment"
                  element={<DoctorAppointment />}
                />
                <Route path="/doctorencounter" element={<DoctorEncounter />} />
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>

      <div className="sidebar-overlay"></div>
    </>
  );
};

export default Approuter;
